import { useQuery } from 'react-query';
import httpClient from '../datasources/httpClient';
/**
 * @param {boolean} enabled
 */
export default function useQueryBackups({ enabled, workspaceId }) {
  return useQuery(
    ['backups'],
    async () => {
      const workspaceFilter = workspaceId ? `&workspaceId=${workspaceId}` : '';
      const response = await httpClient.get(`backups?orderByName=asc&includeReports=true${workspaceFilter}`);

      if (response.status === 401) {
        throw new Error('Unauthorized');
      }

      return response.data;
    },
    {
      enabled,
      staleTime: 1000 * 60,
    },
  );
}
